import { CloseCircleOutlined, WarningOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

export function ComplaintCloseButton ({ onClick, ...props }) {
  const i18n = useTranslation()

  const { confirm } = Modal

  const showConfirm = () => {
    confirm({
      title: i18n.t('common.resources.complaint.actions.close.confirm.title'),
      content: i18n.t('common.resources.complaint.actions.close.confirm.content'),
      okText: i18n.t('common.resources.complaint.actions.close.confirm.ok'),
      cancelText: i18n.t('common.resources.complaint.actions.close.confirm.cancel'),
      icon: <WarningOutlined />,
      okType: 'danger',
      onOk: onClick
    })
  }

  return (
    <Button type='default' danger {...props} onClick={showConfirm}>
      <CloseCircleOutlined /> {i18n.t('common.resources.complaint.actions.close.submit')}
    </Button>
  )
}
